import store from "../store";

export function setManageRoleState(newProp: any){
    store.dispatch(
        {
            type: "setManageRoleState",
            payload: newProp
        }
    )
}